module.exports = "/images/block.png?0042a84711368a1bd2c7b0a4ed6802a4";